'use client';
import Link from 'next/link';
import React from 'react';
import Image from 'next/image';
import { FaLinkedin } from 'react-icons/fa';
import NewsletterForm from '../@generalComponents/NewsletterForm';

const categoriesToShow = [
	'6519604594c1b61a4d62db60',
	'6519604594c1b61a4d62db66',
	'6519604594c1b61a4d62db6c',
	'6519604594c1b61a4d62db6f',
	'6519604594c1b61a4d62db72',
];

const Footer = ({ showFooter = true, categories }) => {
	return (
		<>
			<div className='w-full bg-[#B332E6] text-white text-center py-8 px-12 h-full'>
				<div className='flex flex-col flex-wrap md:flex-row'>
					<div className='flex flex-col-reverse flex-shrink-0 gap-6 mb-8 md:w-1/3 md:flex-col md:mb-4'>
						<Image
							alt='logo-white'
							src='https://i.imgur.com/eGBSCBk.png'
							width={200}
							height={30}
							layout='fixed'
							loading='lazy'
							style={{ objectFit: 'scale-down' }}
						/>
						<NewsletterForm />
					</div>

					<div className='flex-shrink-0 mb-3 md:flex-shrink-0 md:flex-grow-0 md:basis-auto md:w-1/3 md:mb-0'>
						<div>
							<p className='text-2xl font-semibold leading-6 text-left text-white'>
								Categories
							</p>
							{categories?.map((cat, i) => {
								if (categoriesToShow.includes(cat?.categoryId))
									return (
										<Link
											href={`/categories/${cat?.slug}`}
											style={{ all: 'unset' }}
											key={cat?.categoryId}
										>
											<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
												{cat?.name}
											</p>
										</Link>
									);
							})}
						</div>
					</div>
					<div className='flex md:w-1/3'>
						<div>
							<p className='text-2xl font-semibold leading-6 text-left text-white'>
								About
							</p>
							<Link
								href='/pro?from=footer'
								style={{ all: 'unset' }}
							>
								<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
									Pricing
								</p>
							</Link>
							<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
								<a
									style={{
										color: 'inherit',
										textDecoration: 'inherit',
										fontFamily: 'inherit',
									}}
									href='mailto:brands@tinytexts.co?subject=Brand suggestion'
									aria-label='Suggest a brand via email'
								>
									Suggest a brand
								</a>
							</p>
							<Link
								href='/about/privacy'
								style={{ all: 'unset' }}
							>
								<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
									Privacy
								</p>
							</Link>
							<Link
								href='/about/terms-and-conditions'
								style={{ all: 'unset' }}
							>
								<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
									Terms and Conditions
								</p>
							</Link>
							<Link
								href='/about/refund-policy'
								style={{ all: 'unset' }}
							>
								<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
									Refund Policy
								</p>
							</Link>
							<Link
								href='/about/dmca-policy'
								style={{ all: 'unset' }}
							>
								<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
									DMCA Policy
								</p>
							</Link>
							<Link
								href='/about/dmca-request'
								style={{ all: 'unset' }}
							>
								<p className='my-4 text-xl font-medium leading-6 text-left text-white cursor-pointer'>
									DMCA Request
								</p>
							</Link>
						</div>
					</div>
				</div>
				<div className='flex items-center mt-5 gap-4'>
					<a
						href='https://www.linkedin.com/company/tiny-texts/'
						target='_blank'
						rel='noopener noreferrer'
						aria-label='Tiny Texts on LinkedIn'
						className='text-white hover:text-gray-200 flex-shrink-0'
					>
						<FaLinkedin size={36} />
					</a>
					<p className='hidden md:block flex-1 py-2 mb-0 text-sm font-light leading-6 text-center text-white'>
						©2026 Tiny Texts LLC - All rights reserved
					</p>
				</div>
			</div>
			<style jsx>
				{`
					@media screen and (max-width: 576px) {
						.footer {
							padding: 15px 25px 15px 25px;
						}
					}
				`}
			</style>
		</>
	);
};

export default Footer;
